import type { IBodyItem } from "~/feature/insights/types";

import { getFullPageArchive } from "./getFullPageArchive";

interface IRouteMatchLike {
  loaderData: unknown;
}

interface IWithPage {
  page?: { body?: IBodyItem[] | null } | null;
}

const hasPage = (data: unknown): data is IWithPage =>
  typeof data === "object" && data !== null && "page" in data;

export const isFullPageArchive = (matches: IRouteMatchLike[]): boolean =>
  matches.some(
    ({ loaderData }) =>
      hasPage(loaderData) &&
      getFullPageArchive(loaderData.page?.body) !== null
  );
